document.addEventListener("DOMContentLoaded", function () {
  // Reusable function to initialize sliders with customizable scroll speed
  function initializeSplideSlider(sliderClass, scrollSpeed) {
    const sliders = document.querySelectorAll(sliderClass);

    sliders.forEach(function (slider) {
      new Splide(slider, {
        type: "loop",
        drag: "free",
        focus: "center",
        arrows: false,
        autoWidth: true, // Enable CSS-based width
        autoScroll: {
          speed: scrollSpeed,
          pauseOnHover: false,
          pauseOnFocus: false,
        },
      })
        .on("resize", function () {
          console.log("Current perPage:", this.options.perPage);
        })
        .mount(window.splide.Extensions); // Correctly mount extensions
    });
  }

  // Initialize normal sliders
  initializeSplideSlider(".splide_slider", -2);
  initializeSplideSlider(".splide_testimonials_slider", -1);
});